<template>
  <button
    type="button"
    class="primary inline-flex items-center whitespace-nowrap"
    :class="{ compact }"
    v-tooltip="'ALT + F'"
    data-testid="help-chat-agent"
    :aria-label="ariaLabel"
    @click="emit('open')"
  >
    <font-awesome-icon class="mr-2" icon="robot"></font-awesome-icon>
    Agent
    <span
      v-if="badge"
      class="ml-2 inline-flex items-center justify-center min-w-[22px] h-[22px] px-1 bg-red-500 text-white text-xs font-bold rounded-full"
      data-testid="help-chat-unread"
      aria-hidden="true"
    >{{ badge }}</span>
  </button>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { badgeLabel } from "./helpChatUnread.mjs";

defineProps({
  compact: Boolean,
});

const emit = defineEmits(["open"]);
const store = useStore();
const badge = computed(() => badgeLabel(store.state.helpChatUnread));
const ariaLabel = computed(() => (badge.value ? `Agent, ${badge.value} unread` : "Agent"));
</script>

<style scoped>
button.compact {
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>
